
        import { defineNuxtPlugin } from '#app'
        import { dragScroller } from '#imports'

        export default defineNuxtPlugin(({ vueApp }) => {
          vueApp.directive('drag-scroller', dragScroller)
        })
      